const enterpriseAssets = {
  stats: [
    {
      id: 0,
      stat: '30%',
      title: 'Faster',
      copy:
        'Experience seamless collaboration across teams and accelerated creative workflows.',
    },
    {
      id: 1,
      stat: '75%',
      title: 'Of the Fortune 100',
      copy:
        "Trusted partner of over 100,000 organisations, including the world's largest.",
    },
    {
      id: 2,
      stat: '99.9%',
      title: 'Uptime SLA',
      copy:
        'Reliability is critical to any products success, we pride ourselves on always being there.',
    },
  ],
};

export default enterpriseAssets;



// WEBPACK FOOTER //
// ./src/configs/caseStudies/enterprise.js